import { useState, useCallback } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import LoadingButton from '@mui/lab/LoadingButton'
import useToast from 'hooks/useToast'
import Heading from './Heading'
import ShareCodeInput from './ShareCodeInput'
import api from 'services/api'

const GetSourceId = () => {
  const toast = useToast()
  const [shareLink, setShareLink] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [sourceId, setSourceId] = useState(null)

  const getSourceId = useCallback(async () => {
    if (!shareLink) return

    const shareCode = shareLink.trim().split('/').slice(-1)[0]
    try {
      setIsLoading(true)
      setSourceId(null)
      const share = await api.shares.getShare(shareCode)
      setSourceId(share.reclip_source_id)
      toast({ message: 'Source ID found' })
    } catch (e) {
      toast({ message: e.message, severity: 'error' })
    } finally {
      setIsLoading(false)
    }
  }, [shareLink, toast])

  const handleCopy = useCallback(async () => {
    if (!sourceId) return
    try {
      await navigator.clipboard.writeText(sourceId)
      toast({ message: 'Source ID copied to clipboard' })
    } catch (e) {
      toast({ message: 'Failed to copy to clipboard', severity: 'error' })
    }
  }, [sourceId, toast])

  return (
    <Box>
      <Heading text="1. Enter share link" />
      <ShareCodeInput shareLink={shareLink} onChange={setShareLink} />
      <Heading text="2. Get the Source ID" />
      <LoadingButton
        variant="contained"
        disabled={!shareLink}
        onClick={getSourceId}
        loading={isLoading}
      >
        Get Source ID
      </LoadingButton>

      {sourceId && (
        <Box sx={{ mt: 4 }}>
          <Heading text="3. Source ID" />
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'wrap',
            }}
          >
            <Box
              component="code"
              sx={{
                backgroundColor: 'background.paper',
                border: 1,
                borderColor: 'divider',
                borderRadius: 1,
                p: 1.5,
                fontSize: '18px',
                fontFamily: 'monospace',
                userSelect: 'all',
              }}
            >
              {sourceId}
            </Box>
            <Button variant="contained" onClick={handleCopy}>
              Copy
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default GetSourceId
